var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.icon)?_c('div',{ref:"floatBall",staticClass:"float-ball",class:`status_${_vm.dragIconStatus}`},[_c('img',{staticClass:"icon",attrs:{"src":_vm.icon,"alt":""}})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }